import { Component, NgModule, OnInit, Input, ChangeDetectorRef, Inject, PLATFORM_ID, NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Page } from '../shared/navigation/pages.model';
import { SharedModule } from '../shared/shared.module';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/all';
import { isPlatformBrowser } from '@angular/common';
import { NavigationService } from '../shared/navigation/navigation.service';

@Component({
    templateUrl: 'lazy1.component.html',
    styleUrls: ['lazy1.component.scss'],
})

export class Lazy1Component implements OnInit, AfterViewInit, OnDestroy {
    public cdn = environment.cdn;
    public pageName = environment.name;
    public pageTitle: string;
    public pageContent: string;
    public gallery: any;
    public children: Page[] = [];
    public path_offer = '/';
    public path_dealers = '/';
    public path_articles = '/';
    public isMobile = true;
    
    private stage:any;
    private slides:any;
    private links:any;
    private slideID = 0;

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private ngZone: NgZone, private router: Router, private navigationService: NavigationService, private cdr: ChangeDetectorRef) {}

    ngOnInit() { 
        if (isPlatformBrowser(this.platformId)) {
            gsap.registerPlugin(ScrollTrigger);
            gsap.registerPlugin(ScrollToPlugin);
        }
        this.path_offer = this.router.config.find(r => r.data?.module === 'OfferModule' && +r.data.level === 0)?.data.path || '/';
        this.path_dealers = this.router.config.find(x => x.data?.module === 'DistributorsModule')?.data.path || '/';
        this.path_articles = this.router.config.find(r => r.data?.module === 'ArticleModule')?.data.path || '/';

        this.navigationService.mobile.subscribe(mobile => {
            this.isMobile = mobile;
        });
    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId) && !this.isMobile) {
            this.ngZone.runOutsideAngular(() => {
                // this.initHeader();
                const select = e => document.querySelector(e);
                const selectAll = e => document.querySelectorAll(e);
                this.stage = select('.stage');
                this.slides = selectAll(".slide");
                this.links = selectAll(".scroll-link");

                gsap.set(this.stage, { autoAlpha: 1 });
                this.initLinks();
                this.initSlides();
                this.initParallax();
            });
        }
    }

    private initSlides() {
    
        // Animation of each slide scrolling into view
        
        this.slides.forEach((slide, i) => {   
            
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    scrub: 1,
                    start: "0% 50%",
                    end: "50% 50%", 
                    // markers: {startColor: "green", endColor: "red", fontSize: "12px"}
                }
            });
     
            tl.from(slide.querySelectorAll('.slide-content-title'), {
                y: "+=5vh",
                ease: "power2",
                duration: 2.5,
            })
            .from(slide.querySelectorAll('.slide-content-box'), {
                y: -100,
                opacity: 0,
                duration: 2,
                ease: "power2",
                stagger: 0.8
            }, 0)
            // .from(slide.querySelectorAll('.line-inner'), {
            //     x: -100,
            //     opacity: 0,
            //     duration: 2,
            //     ease: "power2",
            //     stagger: 0.1
            // }, 0)
            // .from(slide.querySelectorAll('.content-txt'), {
            //     y: 100,
            //     //y: 50,
            //     opacity: 0,
            //     duration: 2,
            //     ease: "power2"
            // }, 0.4)
            .from(slide.querySelectorAll('.flat-button'), {
                y: 100,
                opacity: 0,
                duration: 2,
                ease: "power2"
            }, 0.3)
            .from(slide.querySelectorAll('.scroll-link'), {
                y: 100,
                duration: 2,
                ease: "power4"
            }, 0.4)
            // .to(slide.querySelectorAll('.slide__scroll-line'), {
            //     scaleY: 0.6,
            //     transformOrigin: "bottom left",
            //     duration: 2.5, 
            //     ease: "elastic(1,0.5)"
            // }, 1.4)

            
        });

        // const tl2 = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: '.footer',
        //         // scrub: true,
        //         start: "40% 50%",
        //     }
        // });

        // tl2.from('.logos', {
        //     opacity: 0,
        //     duration: 1,
        //     ease: "power2"
        // }, 0);
    }
    
    private initParallax() {      
        this.slides.forEach((slide, i) => {
            let imageWrappers = slide.querySelectorAll('.image-wrap');
            
            gsap.fromTo(imageWrappers, {
                y: "-15vh"
            },{
                y: "15vh",
                scrollTrigger: {
                    trigger: slide,
                    scrub: true,
                    start: "top bottom",
                    // snap: {
                    //     snapTo: 0.5,
                    //     duration: 1,
                    //     ease: 'power4.inOut'
                    // }
                },
                ease: 'none'
            })
        });
    }

    private initLinks() {
    
        // ScrollToPlugin links
        
        this.links.forEach((link, index, e) => {     
            
            link.addEventListener("click", (e) => {
                e.preventDefault();
                gsap.to(window, {
                    duration: 2, 
                    scrollTo:{
                        y: "#slide" + (index + 1)
                    },
                    ease: "power2.inOut"
                });
                this.slideID++;
            });
            
        });
    }

    private scrollTop() {
        gsap.to(window, {
            duration: 2, 
            scrollTo: {
                y: 0//"#slide0"
            },
            ease: "power2.inOut"
        });
    }

    ngOnDestroy(): void {
        if (this.links) {
            this.links.forEach((link) => {     
                link.removeAllListeners('click');
            });
        }
        ScrollTrigger.getAll().forEach(t => t.kill());
        gsap.globalTimeline.getChildren().forEach(child => child.kill());
    }
    
}

@NgModule({
    declarations: [Lazy1Component],
    imports: [SharedModule]
})
class Lazy1Module { }